import React from 'react';

export default class ErrorBoundary extends React.Component {
  state = { err: null, info: null };
  static getDerivedStateFromError(err) { return { err }; }
  componentDidCatch(err, info) {
    this.setState({ info });
    console.error('ErrorBoundary caught:', err);
    console.error('Component stack:', info?.componentStack);
    if (err?.stack) console.error('Stack:', err.stack);
  }
  reset = () => { this.setState({ err: null, info: null }); };
  render() {
    if (this.state.err) {
      const err = this.state.err;
      const message = String(err?.message || err);
      const stack = err?.stack || '';
      const compStack = this.state.info?.componentStack || '';
      return (
        <div className="max-w-3xl mx-auto p-6 mt-10 bg-white border border-red-200 rounded-2xl shadow-card">
          <h2 className="text-lg font-bold text-red-700 mb-2">화면 렌더링 중 오류가 발생했습니다</h2>
          <div className="text-sm text-red-700 mb-3">{message}</div>
          {stack && (
            <details className="mb-3" open>
              <summary className="text-xs text-red-700 cursor-pointer font-semibold">Stack trace</summary>
              <pre className="text-[11px] bg-red-50 text-red-800 p-3 rounded overflow-auto whitespace-pre-wrap break-all max-h-64 mt-1">{stack}</pre>
            </details>
          )}
          {compStack && (
            <details className="mb-3">
              <summary className="text-xs text-red-700 cursor-pointer font-semibold">Component stack</summary>
              <pre className="text-[11px] bg-red-50 text-red-800 p-3 rounded overflow-auto whitespace-pre-wrap break-all max-h-64 mt-1">{compStack}</pre>
            </details>
          )}
          <div className="mt-3 flex gap-2">
            <button onClick={this.reset} className="px-3 py-1.5 rounded-md bg-medical-600 hover:bg-medical-700 text-white text-sm font-semibold">다시 시도</button>
            <button onClick={() => location.reload()} className="px-3 py-1.5 rounded-md border border-medical-200 text-medical-700 text-sm">페이지 새로고침</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
